export default {
    props: {
        draggableContainment: {
            type: String,
            default: undefined,
            kComposite: 'draggable.containment'
        }, 
        draggableAxis: {
            type: String,
            default: undefined,
            kComposite: 'draggable.axis'
        }, 
        draggableDragHandle: {
            type: String,
            default: undefined,
            kComposite: 'draggable.dragHandle'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-window-vue-wrapper/src/KendoWindow/Draggable.js